






import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryFinanceAllocateRechargeDailyStatList, ExportFinanceAllocateRechargeDailyStat } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({ components: { VQuery, VTable } })
export default class FinanceAllocateRechargeDailyStatList extends Vue {
  private queryParam = { startRow: 1, limit: 10, statDateDaterange: [], orderBy: 'stat_date desc', statDateTimeScope: '' }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private tableSelectData: any[] = []
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '统计日期', param: 'statDate', width: 120 },
    { title: '批次数', param: 'batchCount' },
    { title: '充值总额', param: 'rechargeTotalQty' },
    { title: '实发合计', param: 'paidTotalQty' },
    { title: '沉淀合计', param: 'sedimentTotalQty' },
    { title: '直推池', param: 'directPoolTotal' },
    { title: '十代池', param: 'tenGenPoolTotal' },
    { title: '流水交叉79', param: 'wealthRecordCrossQty' },
    { title: '更新时间', param: 'updateTime', formatter: DateFormat, width: 160 },
  ]

  public created() { this.loadData() }
  private tableSelectChange(e: any[]) { this.tableSelectData = e }
  private exportHandle() {
    const loading = this.$loading({ lock: true, text: '正在导出', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
    const param: any = this.getRequestParam()
    param.limit = ''
    param.startRow = ''
    if (this.tableSelectData.length > 0) param.ids = this.tableSelectData.map(e => e.id)
    ExportFinanceAllocateRechargeDailyStat(param, '分配充值日汇总.xlsx').finally(() => loading.close())
  }
  public async loadData() {
    const result = await QueryFinanceAllocateRechargeDailyStatList(this.getRequestParam())
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam() {
    const param = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length > 0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }
  public search() { this.tableCurrntPage = 1; this.loadData() }
  public pageChange(index: number) { this.tableCurrntPage = index; this.loadData() }
  public sizeChange(index: number) { this.tableCurrntPage = 1; this.queryParam.limit = index; this.loadData() }
}
